import { useMemo } from "react";
import { FirestoreOrganisationMarketplace } from "reedy-data/api";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

export const LanguageSettingsMarketplaceDropdown = ({
  value,
  onChange,
  className,
  disabled,
}: {
  value?: FirestoreOrganisationMarketplace;
  onChange?: (value: FirestoreOrganisationMarketplace) => void;
  className?: string;
  disabled?: boolean;
}) => {
  const { t } = useTranslation("settings");

  const options: { label: string; value: FirestoreOrganisationMarketplace }[] =
    useMemo(
      () => [
        {
          value: FirestoreOrganisationMarketplace.GER,
          label: t("organisation.settings.marketplace.options.GER"),
        },
        {
          value: FirestoreOrganisationMarketplace.US,
          label: t("organisation.settings.marketplace.options.US"),
        },
        {
          value: FirestoreOrganisationMarketplace.UK,
          label: t("organisation.settings.marketplace.options.UK"),
        },
        {
          value: FirestoreOrganisationMarketplace.AU,
          label: t("organisation.settings.marketplace.options.AU"),
        },
        {
          value: FirestoreOrganisationMarketplace.NONE,
          label: t("organisation.settings.marketplace.options.NONE"),
        },
      ],
      [t],
    );

  return (
    <div className={className}>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          aria-label={t("organisation.settings.marketplace.title")}
        >
          <SelectValue
            placeholder={t("organisation.settings.marketplace.placeholder")}
          />
        </SelectTrigger>
        <SelectContent align="end">
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
